import React, { useState, useEffect } from "react";
import Context from "./index";
import { profiles } from "./UserData/data"; // yeni tek array importu

const UserProvider = (props) => {
  // başlangıçta ilk user profilini aktif yapıyoruz
  const initialUser = profiles.find((p) => p.type === "user");

  const [profileType, setProfileType] = useState(initialUser?.type || "user");

  const [activeProfile, setActiveProfile] = useState(() => {
    const cached = localStorage.getItem("activeProfile");
    return cached ? JSON.parse(cached) : initialUser;
  });

  useEffect(() => {
    if (activeProfile) {
      localStorage.setItem("activeProfile", JSON.stringify(activeProfile));
    }
  }, [activeProfile]);

  // 🔄 profileType'e göre geçiş fonksiyonu
  const switchProfile = (typeOrId) => {
    let target;

    if (typeOrId === "user" || typeOrId === "client") {
      target = profiles.find((p) => p.type === typeOrId);
    } else {
      // eğer id gönderilirse (örnek: u_002)
      target = profiles.find((p) => p.id === typeOrId);
    }

    if (target) {
      setActiveProfile(target);
      setProfileType(target.type);
    } else {
      // Profile not found — no-op until error handling is defined.
    }
  };

  return (
    <Context.Provider
      value={{
        profiles, // 👈 artık tüm profiller context içinde erişilebilir
        profileType,
        activeProfile,
        setActiveProfile,
        switchProfile, // profil değiştirici fonksiyon
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default UserProvider;
